var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { postGenerateMajorId } from "../request/quotation/designQuotationResultController/generateMajorId/post.js";
import { OperateType, ExternalType } from "./type.js";
import { designBaseLog } from "../request/designapi/design/base/log/post.js";
function externalFactory(getRet) {
  return async (params) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S;
    const sequenceId = await postGenerateMajorId();
    let easySequenceId = "";
    if (Array.isArray(params.arg) && params.arg.length > 0) {
      easySequenceId = (_c = (_b = (_a = params.arg) == null ? void 0 : _a[0]) == null ? void 0 : _b.sequenceId) != null ? _c : "";
    }
    let ret;
    let getRetError;
    const shouldLogBefore = ((_d = params.logArg) == null ? void 0 : _d.operate) === "FULL_SPLIT_ORDER" && ((_f = (_e = params.logArg) == null ? void 0 : _e.message) == null ? void 0 : _f.includes("\u5168\u91CF\u62C6\u5355\u4E91\u62C6"));
    let fileId = "";
    let output;
    if (params.logArg && shouldLogBefore) {
      if (Array.isArray(params.arg) && params.arg.length > 0) {
        fileId = (_i = (_h = (_g = params.arg) == null ? void 0 : _g[0]) == null ? void 0 : _h.fileId) != null ? _i : "";
      }
      if (params.arg && typeof params.arg === "object" && "fileId" in params.arg) {
        fileId = params.arg.fileId;
      }
      let designErrorCount = 0;
      let designWarnCount = 0;
      let designTipCount = 0;
      if (params.logArg.operateType === OperateType.CHECK) {
        const checkData = params.type === ExternalType.caxa ? ret : ret == null ? void 0 : ret.data;
        if (Array.isArray(checkData)) {
          const allResults = checkData.flatMap((item) => item.result || []);
          designErrorCount = allResults.filter(({ checkResultLevel }) => checkResultLevel === "3" || checkResultLevel === "4" || checkResultLevel === "5").length;
          designWarnCount = allResults.filter(({ checkResultLevel }) => checkResultLevel === "2").length;
          designTipCount = allResults.filter(({ checkResultLevel }) => checkResultLevel === "1").length;
        }
      }
      output = __spreadValues(__spreadValues(__spreadValues({
        fileId: fileId || ((_j = params.logArg) == null ? void 0 : _j.fileId),
        pageId: (_k = params.logArg) == null ? void 0 : _k.pageId,
        requestId: (_l = params.logArg) == null ? void 0 : _l.requestId,
        operate: (_m = params.logArg) == null ? void 0 : _m.operate,
        beginTime: (_o = (_n = params.logArg) == null ? void 0 : _n.operateTime) != null ? _o : "",
        orderQuantity: (_p = params.logArg) == null ? void 0 : _p.orderQuantity
      }, ((_q = params.logArg) == null ? void 0 : _q.operate) === "FULL_SPLIT_ORDER" ? {} : { endTime: new Date().getTime(), timing: new Date().getTime() - ((_s = (_r = params.logArg) == null ? void 0 : _r.operateTime) != null ? _s : 0) }), ((_t = params.logArg) == null ? void 0 : _t.output) || {
        serviceId: "",
        orderTaskId: "",
        batchId: "",
        errorCount: 0,
        warnCount: 0,
        tipCount: 0,
        designErrorCount,
        designWarnCount,
        designTipCount
      }), params.logArg.operateType === OperateType.CHECK ? {
        designErrorCount,
        designWarnCount,
        designTipCount
      } : {});
      await designBaseLog(__spreadProps(__spreadValues({}, params.logArg), {
        sequenceId: easySequenceId || sequenceId,
        input: JSON.stringify(params.arg),
        output: JSON.stringify(output)
      }));
    }
    try {
      ret = await getRet(__spreadProps(__spreadValues({}, params), {
        sequenceId: easySequenceId || sequenceId,
        type: params.type || ExternalType.caxa,
        taskId: params.taskId || "",
        preTest: (_u = params.logArg) == null ? void 0 : _u.preTest
      }));
    } catch (e) {
      getRetError = e;
    }
    if (params.logArg) {
      if (!shouldLogBefore) {
        if (Array.isArray(params.arg) && params.arg.length > 0) {
          fileId = (_x = (_w = (_v = params.arg) == null ? void 0 : _v[0]) == null ? void 0 : _w.fileId) != null ? _x : "";
        }
        if (params.arg && typeof params.arg === "object" && "fileId" in params.arg) {
          fileId = params.arg.fileId;
        }
        let designErrorCount = 0;
        let designWarnCount = 0;
        let designTipCount = 0;
        if (params.logArg.operateType === OperateType.CHECK) {
          const checkData = params.type === ExternalType.caxa ? ret : ret == null ? void 0 : ret.data;
          if (Array.isArray(checkData)) {
            const allResults = checkData.flatMap((item) => item.result || []);
            designErrorCount = allResults.filter(({ checkResultLevel }) => checkResultLevel === "3" || checkResultLevel === "4" || checkResultLevel === "5").length;
            designWarnCount = allResults.filter(({ checkResultLevel }) => checkResultLevel === "2").length;
            designTipCount = allResults.filter(({ checkResultLevel }) => checkResultLevel === "1").length;
          }
        }
        output = __spreadValues(__spreadValues(__spreadValues({
          fileId: fileId || ((_y = params.logArg) == null ? void 0 : _y.fileId),
          pageId: (_z = params.logArg) == null ? void 0 : _z.pageId,
          requestId: (_A = params.logArg) == null ? void 0 : _A.requestId,
          operate: (_B = params.logArg) == null ? void 0 : _B.operate,
          beginTime: (_D = (_C = params.logArg) == null ? void 0 : _C.operateTime) != null ? _D : "",
          orderQuantity: (_E = params.logArg) == null ? void 0 : _E.orderQuantity
        }, ((_F = params.logArg) == null ? void 0 : _F.operate) === "FULL_SPLIT_ORDER" && ((_H = (_G = params.logArg) == null ? void 0 : _G.message) == null ? void 0 : _H.includes("\u5168\u91CF\u62C6\u5355\u4E91\u62C6")) ? {} : { endTime: new Date().getTime(), timing: new Date().getTime() - ((_J = (_I = params.logArg) == null ? void 0 : _I.operateTime) != null ? _J : 0) }), ((_K = params.logArg) == null ? void 0 : _K.output) || {
          serviceId: "",
          orderTaskId: "",
          batchId: "",
          errorCount: 0,
          warnCount: 0,
          tipCount: 0,
          designErrorCount,
          designWarnCount,
          designTipCount
        }), params.logArg.operateType === OperateType.CHECK ? {
          designErrorCount,
          designWarnCount,
          designTipCount
        } : {});
        await designBaseLog(__spreadProps(__spreadValues({}, params.logArg), {
          sequenceId: easySequenceId || sequenceId,
          input: JSON.stringify(params.arg),
          output: JSON.stringify(output)
        }));
      }
      const outputRes = {
        pageId: (_L = params.logArg) == null ? void 0 : _L.pageId,
        requestId: (_M = params.logArg) == null ? void 0 : _M.requestId,
        operate: (_N = params.logArg) == null ? void 0 : _N.operate,
        beginTime: (_P = (_O = params.logArg) == null ? void 0 : _O.operateTime) != null ? _P : "",
        endTime: new Date().getTime(),
        timing: new Date().getTime() - ((_R = (_Q = params.logArg) == null ? void 0 : _Q.operateTime) != null ? _R : 0),
        orderQuantity: (_S = params.logArg) == null ? void 0 : _S.orderQuantity,
        ret: JSON.stringify(ret != null ? ret : { error: String(getRetError) })
      };
      await designBaseLog(__spreadProps(__spreadValues({}, params.logArg), {
        sequenceId: easySequenceId || sequenceId,
        input: JSON.stringify(params.arg),
        output: JSON.stringify(outputRes)
      }));
      console.log("\u5728\u8FD9\u91CC\u57CB\u70B9--", params);
    }
    if (getRetError) {
      throw getRetError;
    }
    return ret;
  };
}
export { externalFactory };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalFactory.js